import PropTypes from 'prop-types';

export function PersonFullName(
  {
    name,
    middleName,
    lastName,
    motherLastName
  }
) {
  return (
    <>
      {
      [
        name,
        middleName,
        lastName,
        motherLastName
      ].filter(Boolean).join(' ')
    }
    </>
  );
}

export default PersonFullName;

PersonFullName.propTypes = {
  name: PropTypes.string.isRequired,
  middleName: PropTypes.string,
  lastName: PropTypes.string,
  motherLastName: PropTypes.string
};
